import { AppPromoCodeDetails } from '../types';

// this function to get promotions payload items for each line item
export const getPromotionsPayloadItems = (promotions?: AppPromoCodeDetails[], isFreeProduct?: boolean) => {
  const promotionsArr = promotions?.map((promotion) => {
    if (isFreeProduct) return null;
    // existing promotion code data will be having promotionCode in the response but new promotion code data will be having promocode
    const promocode = promotion?.promotionCode || promotion?.promocode;
    if (promocode) {
      return { promotionDefinition: { promotionId: '', promotionCode: promocode } };
    }
    if (promotion.id) {
      return { promotionDefinition: { promotionId: promotion.id } };
    }
  });
  return promotionsArr?.filter((promotion) => !!promotion) ?? [];
};
